import * as $ from "jquery";
import imkt from '../imkt';

var datepickerRequest = $.Deferred();
var select2Request = $.Deferred();
var underscoreRequest = $.Deferred();

var getStyle = function (url: string, params: any) {
  "use strict";

  // If there is no URL to load, no point in continuing.
  if (typeof url === "undefined") {
    return;
  }

  // If this stylesheet has already been loaded, no point in continuing.
  if (
    params.hasOwnProperty("id") &&
    $("head").find("#" + params.id).length
  ) {
    return;
  }

  var linkAttrs = {
    rel: "stylesheet",
    media: "screen",
    href: url,
  };

  if ($.isPlainObject(params)) {
    linkAttrs = Object.assign({}, linkAttrs, params);
  }

  var link = $("<link>").attr(linkAttrs);
  $("head").append(link);
};

export default {
  datepicker: function (callback) {
    if (typeof datepickerRequest === "undefined") {
      datepickerRequest = $.getScript(
        imkt.constants.libPath +
          "air-datepicker.js" +
          imkt.constants.cdnVersionQuery
      );
      getStyle(
        imkt.constants.libPath +
          "air-datepicker.css" +
          imkt.constants.cdnVersionQuery,
        {
          id: "datepicker-style",
        }
      );
    } else {
      // Select2 already exists
      datepickerRequest.resolve();
    }
    $.when(datepickerRequest).then(callback);
    return this;
  },
  select2: function (callback) {
    // Select2 is a dependency, so load that first
    if (typeof select2Request === "undefined") {
      select2Request = $.getScript(
        imkt.constants.libPath + "select2.js" + imkt.constants.cdnVersionQuery
      );
    } else {
      // Select2 already exists
      select2Request.resolve();
    }
    $.when(select2Request).then(callback);
    return this;
  },
  underscore: function (callback) {
    // underscore is a dependency, so load that first
    if (typeof underscoreRequest === "undefined") {
      underscoreRequest = $.getScript(
        imkt.constants.libPath +
          "underscore.js" +
          imkt.constants.cdnVersionQuery
      );
    } else {
      // underscore already exists
      underscoreRequest.resolve();
    }
    $.when(underscoreRequest).then(callback);
    return this;
  },
};
